/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import { useAppDispatch, useAppSelector } from "../../hooks/store";
import { useGetCmsMutation } from "../../services/cms";
import { useLazyGetAllCmsQuery } from "../../services/settings";
import Loader from "../../helpers/constants/Loader";

const PrivacyPolicy = () => {
  const [getCmsMethod] = useLazyGetAllCmsQuery();
  const [cmsData, setCmsData] = useState<any>("");
  const [loading, setLoading] = useState(false);

  const getCmsDataApi = async () => {
    setLoading(true);
    try {
      const res = await getCmsMethod({}).unwrap();
      if (res?.status === 200) {
        setLoading(false);
        setCmsData(res?.data);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getCmsDataApi();
  }, []);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Loader isLoad={loading} />
      <div style={{ paddingRight: 20, paddingLeft: 20 }}>
        <figure
          style={{
            paddingTop: "10px",
            paddingBottom: "20px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            src="/static/images/logo.png"
            style={{ width: "150px", height: "60px", alignSelf: "center" }}
          />
        </figure>
        <h1 style={{ textAlign: "center" }}>Privacy Policy</h1>
        <div
          style={{ textAlign: "center", fontSize: "22px" }}
          dangerouslySetInnerHTML={{
            __html: cmsData ? cmsData?.privacy_policy : "No Data Found",
          }}
        ></div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
